import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import GridContainer from './components/GridContainer';
import { useSelector } from 'react-redux';
import { useGameSounds } from '@educaplay/core';
import { RELACIONAR_SOUNDS } from './utils/constants';

// eslint-disable-next-line no-unused-vars
const Game = forwardRef(function Game({ onAnswer }, ref) {
  const currentIndex = useSelector(state => state.game.currentIndex);
  const gameSound = useGameSounds();
  
  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
    },
    animateFail: async () => {
    }
  }));

  const [draw, setDraw] = useState(false);

  useEffect(() => {
    gameSound.play(RELACIONAR_SOUNDS.COLLECT);
    setTimeout(() => {
      setDraw(true);
    }, 100);
  }, [currentIndex, gameSound]);

  return (
    <GridContainer onAnswer={onAnswer} draw={draw} setDraw={setDraw} />
  )
})

export default Game